import type { Prototype } from "../prototype-types";

export const leonKempersPrototypes: Prototype[] = [
  {
    id: "gong-os-analysis",
    name: "Gong OS Analysis",
    path: "/lk/gong-os-analysis",
    description:
      "Analysis of 624 Gong call transcripts from Faire's Opening Soon sales motion. Findings on lead quality, OwF mention impact on apply rate, and retailer-state cohort conversion. Run by Leon Kempers using Claude.",
    owner: "Leon Kempers",
    createdAt: "2026-05-11",
    lastUpdated: "2026-05-11",
    surfaceArea: "Other",
    category: "experimental",
    status: "in-progress",
    creationTool: "claude-code",
      thumbnail: "https://cdn.prerelease.faire.dev/fastly/c45bdf6f9f7611e0d39b4198a5a1d14308b0cbc92aeb1a1d45314a43c8030d27.png"
},
  {
    id: "opening-soon-h2-strategy",
    name: "Opening Soon H2 Strategy",
    path: "/lk/opening-soon-h2-strategy",
    description:
      "Working draft of Faire's Opening Soon H2 strategy. Three bets to help OS retailers become ready: build confidence to buy, meet retailers at the right moment, and become the place they learn. Drafted by Leon Kempers.",
    owner: "Leon Kempers",
    createdAt: "2026-05-14",
    lastUpdated: "2026-05-14",
    surfaceArea: "Other",
    category: "experimental",
    status: "in-progress",
    creationTool: "claude-code",
      thumbnail: "https://cdn.prerelease.faire.dev/fastly/e27c7e1e059a66e578d6ae1cb376c036ae4b1fdfd0caacb54ec8b019d18d639d.png"
},
  {
    id: "lk-os-brand-order-confirmation",
    name: "OS Brand Order Confirmation",
    path: "/lk/os-brand-order-confirmation",
    description: "Redesigns a brand&#39;s first order from an Opening Soon retailer: a distinct celebratory moment on the order page and a verified &#39;trust profile&#39; vetting modal surfacing the store&#39;s intro, IDV, resale/tax ID, and OS value (3× more likely to become a top account).",
    owner: "Leon Kempers",
    createdAt: "2026-07-01",
    lastUpdated: "2026-07-01",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "https://cdn.prerelease.faire.dev/fastly/f7ef4b59c1d15ecc6e2cbe01f557a3b2a2464c1c165f915aad80d2eeabbeab53.png",
    creationTool: "claude-code",
  }
];
